import { CommentOutlined, HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Button, FloatButton } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link, Route, useLocation } from "react-router-dom";
import styled from "styled-components";
import "./navbar.css";

const HeadContainer = styled.header`
  background: #ffffff;
  padding: 16px 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid rgba(var(--b6a, 219, 219, 219), 1);

  @media (max-width: 900px) {
    padding: 16px 32px;
  }

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

const HeaderLogo = styled.img`
  height: 40px;
  width: 120px;
  object-fit: cover;
`;

const NavBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { phone_cust } = useParams();
  const [pathset, setPath] = useState("");
  const [pathorder, setPathorder] = useState("");
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");

  const gopath = () => {
    const pathsplit = currentPath.split("/");
    setPath(pathsplit[3]);
  };

  useEffect(() => {
    if (pathset) {
      window.location = `/register-warranty/profile/${pathset}/${mode}`;
    }
  }, [pathset]);

  const gopathhome = () => {
    const pathsorderplit = currentPath.split("/");
    setPathorder(pathsorderplit[3]);
  };

  useEffect(() => {
    if (pathorder) {
      console.log(pathorder);
      window.location = `/register-warranty/order_list/${pathorder}?mode=${mode}`;
    }
  }, [pathorder]);

  const shouldShowButtons = ![
    "/",
    `/^\/register\/\d{10}$/`,
    "/register-warranty/login",
  ].includes(location.pathname);
  // const shouldShowButtons = currentPath === "" && currentPath === "/login/" && currentPath.includes("/register/");

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const goline = () => {
    window.open(
      "https://page.line.me/wif8109n?oat__id=1190551&openQrModal=true",
    );
  };

  return (
    <HeadContainer>
      <HeaderLogo src={"/warranty-images/logo.png"}></HeaderLogo>
      {shouldShowButtons && (
        <div>
          <Button
            style={{ color: "#30b4ac" }}
            shape="circle"
            icon={<UserOutlined />}
            onClick={gopath}
            className="profilepage"
          />
          <Button
            style={{ color: "#30b4ac" }}
            shape="circle"
            icon={<HomeOutlined />}
            onClick={gopathhome}
          />
        </div>
      )}

      <FloatButton
        style={{
          height: "50px",
          width: "50px",
          display: "flex",
          alignItems: "center", // Center content vertically
          justifyContent: "center", // Center content horizontally
        }}
        icon={<CommentOutlined />}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={goline}
      >
        {isHovered ? "Contact" : null}
      </FloatButton>
    </HeadContainer>
  );
};

export default NavBar;
